module.exports = __webpack_public_path__ + "static/media/ic-dental.8d151a29.svg";